import PropTypes from "prop-types";
import { ImageSourcesType } from "../Image/types";

export const GameHeroType = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  imgSources: ImageSourcesType.isRequired,
  reverse: PropTypes.bool,
  border: PropTypes.bool,
  appLinks: PropTypes.bool,
  anchorWrapper: PropTypes.func,
};
